export default "__VITE_ASSET__t70prTw6q$NRQ55cjpIuqg__ 480w, __VITE_ASSET__eCqI$lvWQ4xjFpnVHyoJIA__ 745w";